// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4e7ad5d2","732":"724917bd"}[chunkId] + ".chunk.js";
};